import { Component } from "react";
import { connect } from "react-redux";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import CustomScrollbars from "util/CustomScrollbars";
import Auxiliary from "util/Auxiliary";
import Avatar from "components/Avatar";
import IntlMessages from "util/IntlMessages";
import { injectIntl } from 'react-intl';
import Projet from "components/Projet";
import MenuAdmin from '../Menus/MenuAdmin';
import MenuUser from '../Menus/MenuUser';
import MenuComedien from '../Menus/MenuComedien';

import {
  USER_ROLE_COMEDIEN,
  USER_ROLE_UTILISATEUR,
  USER_ROLE_ADMIN,
} from "constants/General";

import noAvatar from "assets/images/no-avatar.webp";
import { APPLICATION_PATHS } from "constants/ApplicationPaths";
import { withRouter } from "util/withRouter";

import {
  signOutAction
} from "appRedux/actions/Auth";

class MobileMenuContent extends Component {
  constructor() {
    super();
    this.state = {
    }
  }

  signOut = () => {
    this.props.signOutAction();
  };

  renderMainMenu = () => {
    const { pathname } = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];

    return (
      <div className="cm-mobile-menu-main">
        <Menu
          defaultOpenKeys={[defaultOpenKeys]}
          selectedKeys={[selectedKeys]}
          theme='dark'
          mode="inline"
        >
          <Menu.Item key={APPLICATION_PATHS.HOME}>
            <Link to={APPLICATION_PATHS.HOME}>
              <div className="cm-mobile-menu-main-item">
                <div className="cm-mobile-menu-main-item-title">
                  <IntlMessages id="menu.mobile.home" />
                </div>
                <div className="cm-mobile-menu-main-item-icon">
                  <i className="fas fa-home"></i>
                </div>
              </div>
            </Link>
          </Menu.Item>


          <Menu.Item key='projet'>
            <span onClick={this.props.onDisplayModalProjet}>
              <div className="cm-mobile-menu-main-item">
                <div className="cm-mobile-menu-main-item-title">
                  <IntlMessages id="menu.mobile.projet" />
                </div>
                <div className="cm-mobile-menu-main-item-icon">
                  <i className="fas fa-briefcase"></i>
                </div>
              </div>
            </span>
          </Menu.Item>

          <Menu.Item key={APPLICATION_PATHS.DECOUVERTE}>
            <Link to={APPLICATION_PATHS.DECOUVERTE}>
              <div className="cm-mobile-menu-main-item">
                <div className="cm-mobile-menu-main-item-title">
                  <IntlMessages id="menu.mobile.decouverte" />
                </div>
                <div className="cm-mobile-menu-main-item-icon">
                  <i className="fa-regular fa-compass" style={{ marginRight: "0px" }}></i>
                </div>
              </div>
            </Link>
          </Menu.Item>

          <Menu.Item key={APPLICATION_PATHS.AIDE}>
            <Link to={APPLICATION_PATHS.AIDE}>
              <div className="cm-mobile-menu-main-item">
                <div className="cm-mobile-menu-main-item-title">
                  <IntlMessages id="menu.mobile.aide" />
                </div>
                <div className="cm-mobile-menu-main-item-icon">
                  <i className="far fa-question-circle" style={{ fontSize: "20px" }}></i>
                </div>
              </div>
            </Link>
          </Menu.Item>

        </Menu>

        <Projet
          visible={this.state.showModalProjet}
          onCancel={this.onCancelModalProjet}
        />

      </div>
    )
  }


  renderMenuAnonymousUser = () => {
    const { pathname } = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];

    return (
      <div className="cm-mobile-menu-anonymous">

        <CustomScrollbars className="cm-mobile-menu-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme='dark'
            mode="inline"
          >

            <Menu.Item key='signUp'>
              <span onClick={this.props.onSignUp}>
                <IntlMessages id="menu.mobile.signUp" />
              </span>
            </Menu.Item>

            <Menu.Item key='signIn'>
              <span onClick={this.props.onSignIn}>
                <IntlMessages id="menu.mobile.signIn" />
              </span>
            </Menu.Item>

          </Menu>
        </CustomScrollbars>
      </div>
    )
  }

  renderMenuConnectedUser = () => {
    const { currentUser } = this.props;

    let userAvatar = ""
    if (currentUser.photo && (currentUser.photo !== '')) {
      userAvatar = currentUser.photo;
    } else {
      userAvatar = noAvatar;
    }

    return (
      <Auxiliary>
        <div className="cm-mobile-menu-avatar">
          <Avatar
            src={userAvatar}
            width="96px"
            height="96px"
          />
        </div>

        <div className="cm-mobile-menu-name">
          {currentUser.prenom + ' ' + currentUser.nom}
        </div>


        <CustomScrollbars className="cm-mobile-menu-scrollbar">

          {(() => {
            if (currentUser.typeCompte === USER_ROLE_ADMIN) {
              return (
                <MenuAdmin />
              )
            } else if (currentUser.typeCompte === USER_ROLE_UTILISATEUR) {
              return (
                <MenuUser />
              )
            } else if (currentUser.typeCompte === USER_ROLE_COMEDIEN) {
              return (
                <MenuComedien />
              )
            } else {
              return (
                null
              )
            }
          })()}

          <div className="cm-mobile-menu-auth-action">
            <span onClick={this.signOut}>
              <IntlMessages id="menu.mobile.signOut" />
            </span>
          </div>

          <div style={{ marginTop: "50px" }}></div>

        </CustomScrollbars>

      </Auxiliary>
    );
  }

  render() {
    const { currentUser } = this.props;

    return (
      <div className="cm-mobile-menu-content">

        {this.renderMainMenu()}

        {(() => {
          if (currentUser) {
            return (
              <div>
                {this.renderMenuConnectedUser()}
              </div>
            )
          } else {
            return (
              <div>
                {this.renderMenuAnonymousUser()}
              </div>
            )
          }
        })()}

      </div>
    );
  }
}

MobileMenuContent.propTypes = {};

const mapStateToProps = ({ settings, auth }) => {
  const {
    navStyle,
    themeType,
    locale,
    pathname
  } = settings;

  const {
    currentUser
  } = auth;

  return {
    navStyle,
    themeType,
    locale,
    pathname,
    currentUser
  }
};


export default withRouter(injectIntl(connect(
  mapStateToProps,
  {
    signOutAction
  })(MobileMenuContent)));